// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_menuAbsoluteBox__82ssp {
  position: absolute;
  box-sizing: border-box;

  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;



  /* background: #ffffff; */

  box-sizing: border-box;
  box-shadow: 0px 4px 9px rgba(0, 0, 0, 0.09);
  border-radius: 4px;
  left: 10px;
  right: unset;
  bottom: 100%;
  z-index: 3899;
  padding: 0 10px;
}
.styles_fileUpload__XnnDi input[type="file"] {
  display: none;
}
.styles_fileButton__okkNL{
  display:flex;
  justify-content: center;
  align-items:center;
  background-color: #fff;
  height:44px;
  width:44px;
  position:relative;
  border-radius:50%;
  margin:5px;
  cursor:pointer;

}
.styles_emojiIcon__mZ-Pk {
  margin: 0 10px;
  cursor: pointer;
}

.styles_themeLeft__j6\\+lV {
  left: 10px;
  right: unset
}

.styles_themeLeftLtr__wdY6g {
  right: 10px;
  left: unset;
}

/* .langLeft{left:30px;}
  .themeLangLtr{
    left:-100px;
  } */

.styles_boxWidth__lKvgi {
  width: 150px !important;
}

.styles_footerInputContainer__SJcCn {
  box-sizing: border-box;
  width: calc(100% - 40px);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: auto;
  background-color: white;
  border-radius: 10px;
}

.styles_footerInputContainer__SJcCn input,
.styles_footerInputContainer__SJcCn textarea {
  border: unset !important;
  width: calc(100% - 70px);
  overflow: auto;
  resize: none;
  padding: 8px 10px !important;
  font-family: IranSansFaNum !important
}

.styles_footerInputContainer__SJcCn textarea::-webkit-scrollbar {
  display: none;
}

.styles_zIndex__JT2B0 {
  z-index: 2;
}

.styles_sendButton__SSUOB {
  background-color: unset !important;
  border: unset !important;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #000;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.styles_fileUpload__XnnDi {

  /* display:flex;
    justify-content: center;
    align-items:center;
    background-color: #fff;
    height:44px;
    width:44px; */
}

.styles_fileUpload__XnnDi input[type="file"] {
  display: none;
}

.styles_modalStyle__fwfQv {

  justify-content: flex-end;
  align-items: flex-end;
  width: 100%;
}

.styles_shareUserWidth__-KMqg {
  /* width: calc(100% - 24%) !important; */
  width: calc(100vw - 24vw) !important;
}

.styles_modalRtl__Fn7Ac {
  left: 0 !important;
  right: unset !important;
}

.styles_modalLtr__ECk5B {
  right: 0 !important;
  left: unset !important;
}

.styles_modalStyle__fwfQv>div {
  width: 100%;
  height: 47vh;
  min-height: 400px;
}

.styles_modalStyle__fwfQv>div>div {
  width: 100%;
  height: 100%;
  border-radius: 30px 30px 0px 0px;
  box-shadow: unset !important;
}

/* .modalStyle>div>div>div,   .modalStyle>div>div>div>div{
    width:100%;
    height:100%;
  } */

/* .modalStyle>div>div>div>div>div{
    width:100%;

  }
  .modalStyle>div>div>div>div>div:last-child{
    border-radius: 4px;
  } */


@media only screen and (max-width: 800px) {
  .styles_shareUserWidth__-KMqg {
    /* width: calc(100% - 24%) !important; */
    width: calc(100vw - 34%) !important;
  }
}

@media only screen and (max-width: 650px) {
  .styles_shareUserWidth__-KMqg {
    /* width: calc(100% - 24%) !important; */
    width: calc(100vw) !important;
  }
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/OnlineChat/ChatFooter/styles.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,sBAAsB;;EAEtB,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;;;;EAIvB,yBAAyB;;EAEzB,sBAAsB;EACtB,2CAA2C;EAC3C,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,UAAU;EACV,iBAAiB;EACjB,iBAAiB;EACjB,UAAU;EACV,cAAc;;AAEhB;AACA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,UAAU;EACV;AACF;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;;;KAGK;;AAEL;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,wBAAwB;EACxB,wBAAwB;EACxB,cAAc;EACd,YAAY;EACZ,4BAA4B;EAC5B;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;EACxB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE;;;;;iBAKe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,wCAAwC;EACxC,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;;;KAGK;;AAEL;;;;;;KAMK;;;AAGL;EACE;IACE,wCAAwC;IACxC,mCAAmC;EACrC;AACF;;AAEA;EACE;IACE,wCAAwC;IACxC,6BAA6B;EAC/B;AACF","sourcesContent":[".menuAbsoluteBox {\n  position: absolute;\n  box-sizing: border-box;\n\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n\n\n\n  /* background: #ffffff; */\n\n  box-sizing: border-box;\n  box-shadow: 0px 4px 9px rgba(0, 0, 0, 0.09);\n  border-radius: 4px;\n  left: 10px;\n  right: unset;\n  bottom: 100%;\n  z-index: 3899;\n  padding: 0 10px;\n}\n.fileUpload input[type=\"file\"] {\n  display: none;\n}\n.fileButton{\n  display:flex;\n  justify-content: center;\n  align-items:center;\n  background-color: #fff;\n  height:44px;\n  width:44px;\n  position:relative;\n  border-radius:50%;\n  margin:5px;\n  cursor:pointer;\n\n}\n.emojiIcon {\n  margin: 0 10px;\n  cursor: pointer;\n}\n\n.themeLeft {\n  left: 10px;\n  right: unset\n}\n\n.themeLeftLtr {\n  right: 10px;\n  left: unset;\n}\n\n/* .langLeft{left:30px;}\n  .themeLangLtr{\n    left:-100px;\n  } */\n\n.boxWidth {\n  width: 150px !important;\n}\n\n.footerInputContainer {\n  box-sizing: border-box;\n  width: calc(100% - 40px);\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  height: auto;\n  background-color: white;\n  border-radius: 10px;\n}\n\n.footerInputContainer input,\n.footerInputContainer textarea {\n  border: unset !important;\n  width: calc(100% - 70px);\n  overflow: auto;\n  resize: none;\n  padding: 8px 10px !important;\n  font-family: IranSansFaNum !important\n}\n\n.footerInputContainer textarea::-webkit-scrollbar {\n  display: none;\n}\n\n.zIndex {\n  z-index: 2;\n}\n\n.sendButton {\n  background-color: unset !important;\n  border: unset !important;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #000;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.fileUpload {\n\n  /* display:flex;\n    justify-content: center;\n    align-items:center;\n    background-color: #fff;\n    height:44px;\n    width:44px; */\n}\n\n.fileUpload input[type=\"file\"] {\n  display: none;\n}\n\n.modalStyle {\n\n  justify-content: flex-end;\n  align-items: flex-end;\n  width: 100%;\n}\n\n.shareUserWidth {\n  /* width: calc(100% - 24%) !important; */\n  width: calc(100vw - 24vw) !important;\n}\n\n.modalRtl {\n  left: 0 !important;\n  right: unset !important;\n}\n\n.modalLtr {\n  right: 0 !important;\n  left: unset !important;\n}\n\n.modalStyle>div {\n  width: 100%;\n  height: 47vh;\n  min-height: 400px;\n}\n\n.modalStyle>div>div {\n  width: 100%;\n  height: 100%;\n  border-radius: 30px 30px 0px 0px;\n  box-shadow: unset !important;\n}\n\n/* .modalStyle>div>div>div,   .modalStyle>div>div>div>div{\n    width:100%;\n    height:100%;\n  } */\n\n/* .modalStyle>div>div>div>div>div{\n    width:100%;\n\n  }\n  .modalStyle>div>div>div>div>div:last-child{\n    border-radius: 4px;\n  } */\n\n\n@media only screen and (max-width: 800px) {\n  .shareUserWidth {\n    /* width: calc(100% - 24%) !important; */\n    width: calc(100vw - 34%) !important;\n  }\n}\n\n@media only screen and (max-width: 650px) {\n  .shareUserWidth {\n    /* width: calc(100% - 24%) !important; */\n    width: calc(100vw) !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menuAbsoluteBox": `styles_menuAbsoluteBox__82ssp`,
	"fileUpload": `styles_fileUpload__XnnDi`,
	"fileButton": `styles_fileButton__okkNL`,
	"emojiIcon": `styles_emojiIcon__mZ-Pk`,
	"themeLeft": `styles_themeLeft__j6+lV`,
	"themeLeftLtr": `styles_themeLeftLtr__wdY6g`,
	"boxWidth": `styles_boxWidth__lKvgi`,
	"footerInputContainer": `styles_footerInputContainer__SJcCn`,
	"zIndex": `styles_zIndex__JT2B0`,
	"sendButton": `styles_sendButton__SSUOB`,
	"modalStyle": `styles_modalStyle__fwfQv`,
	"shareUserWidth": `styles_shareUserWidth__-KMqg`,
	"modalRtl": `styles_modalRtl__Fn7Ac`,
	"modalLtr": `styles_modalLtr__ECk5B`
};
export default ___CSS_LOADER_EXPORT___;
